import { useEffect, useRef } from 'react'

type Props = {
  itemName: string
  itemImage?: React.ReactNode
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

function DeletePostItemModal({ itemName, itemImage, open, onClose, onConfirm }: Props) {
  const ref = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    if (!ref.current) return
    if (open) {
      ref.current.showModal()
    } else {
      ref.current.close()
    }
  }, [open])

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  return (
    <dialog
      ref={ref}
      id='delete-post-item-modal'
      className='modal'
      onCancel={e => {
        e.preventDefault()
        handleClose()
      }}>
      <div className='modal-box'>
        <h3 className='font-bold text-lg'>{`Excluir item "${itemName}"`}</h3>
        <p className='py-4'>O item em questão será exluído permanentemente.</p>
        {itemImage}
        <div className='modal-action'>
          <form className='flex gap-2' method='dialog'>
            <button className='btn btn-error' onClick={onConfirm}>
              Confirmar
            </button>
            <button className='btn' onClick={handleClose}>
              Cancelar
            </button>
          </form>
        </div>
      </div>
      <label className='modal-backdrop' htmlFor='delete-post-item-modal' onClick={handleClose}>
        Cancelar
      </label>
    </dialog>
  )
}

export default DeletePostItemModal
